import IcoMoon from 'react-icomoon'
import styled from 'styled-components'

const StyledIcon = styled(IcoMoon)`
  box-sizing: initial;
`

export { StyledIcon }
